import React from "react"
import { Flex, Box, Heading, Text, Link } from "rebass"
import { Link as GatsbyLink } from "gatsby"

const InstagramIcon = props => (
  <svg
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
    height="27"
    viewBox="0 0 140 140"
  >
    <g clip-path="url(#clip0)">
      <path d="M119.902 49.4003C119.668 44.0867 118.809 40.4341 117.578 37.2686C116.308 33.9088 114.354 30.9008 111.795 28.4001C109.294 25.8605 106.266 23.8871 102.945 22.6372C99.762 21.4065 96.1281 20.547 90.8148 20.313C85.4616 20.0586 83.7622 20 70.1854 20C56.6085 20 54.9091 20.0586 49.5759 20.293C44.2625 20.5274 40.6097 21.3874 37.4452 22.6173C34.0844 23.8871 31.0764 25.8406 28.5757 28.4001C26.0361 30.9006 24.0637 33.9285 22.8128 37.2495C21.5821 40.4341 20.7228 44.0672 20.4886 49.3803C20.2344 54.7335 20.1756 56.4329 20.1756 70.0098C20.1756 83.5866 20.2344 85.2862 20.4686 90.6193C20.7031 95.9328 21.563 99.5855 22.7939 102.751C24.0637 106.111 26.0361 109.119 28.5757 111.619C31.0764 114.159 34.1043 116.132 37.4253 117.382C40.6095 118.613 44.2426 119.473 49.5569 119.707C54.8892 119.942 56.5895 120 70.1664 120C83.7433 120 85.4426 119.942 90.7759 119.707C96.0892 119.472 99.7421 118.613 102.907 117.382C106.23 116.097 109.249 114.132 111.768 111.612C114.288 109.093 116.254 106.074 117.539 102.751C118.769 99.5665 119.629 95.9326 119.863 90.6193C120.098 85.2862 120.156 83.5866 120.156 70.0098C120.156 56.4329 120.136 54.7333 119.902 49.4003ZM110.897 90.2286C110.682 95.1123 109.861 97.7496 109.178 99.5077C107.497 103.864 104.04 107.322 99.6833 109.002C97.9252 109.686 95.269 110.506 90.4042 110.72C85.1297 110.956 83.5479 111.013 70.2053 111.013C56.8626 111.013 55.261 110.956 50.0055 110.72C45.1217 110.506 42.4845 109.686 40.7263 109.002C38.5585 108.201 36.5853 106.931 34.9834 105.271C33.3229 103.649 32.0531 101.696 31.2518 99.5276C30.5681 97.7695 29.7478 95.1123 29.5335 90.2485C29.2983 84.974 29.2405 83.3913 29.2405 70.0486C29.2405 56.706 29.2983 55.1043 29.5335 49.8498C29.7478 44.966 30.5681 42.3288 31.2518 40.5706C32.0531 38.4018 33.3229 36.429 35.0033 34.8267C36.6239 33.1662 38.5774 31.8965 40.7462 31.0961C42.5044 30.4124 45.1615 29.5919 50.0254 29.3768C55.2998 29.1424 56.8826 29.0838 70.2242 29.0838C83.5868 29.0838 85.1686 29.1424 90.4241 29.3768C95.3078 29.5921 97.9451 30.4122 99.7032 31.0959C101.871 31.8965 103.844 33.1662 105.446 34.8267C107.107 36.4483 108.376 38.4018 109.178 40.5706C109.861 42.3288 110.682 44.985 110.897 49.8498C111.131 55.1242 111.19 56.706 111.19 70.0486C111.19 83.3913 111.131 84.9541 110.897 90.2286H110.897Z" />
      <path d="M70.1856 44.3212C56.0035 44.3212 44.497 55.8269 44.497 70.0098C44.497 84.1926 56.0035 95.6984 70.1856 95.6984C84.368 95.6984 95.8742 84.1926 95.8742 70.0098C95.8742 55.8269 84.368 44.3212 70.1856 44.3212ZM70.1856 86.6732C60.985 86.6732 53.5218 79.2112 53.5218 70.0098C53.5218 60.8084 60.985 53.3464 70.1854 53.3464C79.3868 53.3464 86.849 60.8084 86.849 70.0098C86.849 79.2112 79.3866 86.6732 70.1856 86.6732V86.6732ZM102.888 43.3053C102.888 46.6173 100.202 49.3026 96.8896 49.3026C93.5778 49.3026 90.8926 46.6173 90.8926 43.3053C90.8926 39.993 93.5778 37.3085 96.8898 37.3085C100.202 37.3085 102.888 39.993 102.888 43.3055V43.3053Z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="100"
          height="100"
          fill="white"
          transform="translate(20 20)"
        />
      </clipPath>
    </defs>
  </svg>
)

const EmailIcon = props => (
  <svg
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
    height="25"
    viewBox="0 0 479.058 479.058"
  >
    <path d="M434.146 59.882H44.912C20.146 59.882 0 80.028 0 104.794v269.47c0 24.766 20.146 44.912 44.912 44.912h389.234c24.766 0 44.912-20.146 44.912-44.912v-269.47c0-24.766-20.146-44.912-44.912-44.912zm0 29.941c2.034 0 3.969.422 5.738 1.159L239.529 264.631 39.173 90.982a14.902 14.902 0 015.738-1.159zm0 299.411H44.912c-8.26 0-14.971-6.71-14.971-14.971V122.615l199.778 173.141c2.822 2.441 6.316 3.655 9.81 3.655s6.988-1.213 9.81-3.655l199.778-173.141v251.649c-.001 8.26-6.711 14.97-14.971 14.97z" />
  </svg>
)

export default function Footer() {
  return (
    <Flex flexDirection="column" py={64} alignItems="center">
      <Flex mb={24} alignItems="center">
        <Box mr={2}>
          <a href="/" style={{ textDecoration: "none" }}>
            <Heading
              fontSize={25}
              as="h1"
              mb={1}
              sx={{ textTransform: "uppercase" }}
            >
              GW
            </Heading>
          </a>
        </Box>

        <Box mx={2} mb={0.5}>
          <a href="https://www.instagram.com/gregwoodwardphoto/" rel="noopener noreferrer" target="_blank">
            <InstagramIcon fill="#303030" />
          </a>
        </Box>
        <Box ml={2}>
          <a href="mailto:info@gregwoodwardphoto.com">
            <EmailIcon fill="#303030" />
          </a>
        </Box>
      </Flex>

      <Text variant="smallprint">
        All content & images copyright © Greg Woodward 2009-Present
      </Text>
      <Text variant="smallprint">
        Website made by <Link href="https://plank.ai">plank.ai</Link>
      </Text>
      <Text variant="smallprint">
        <Link as={GatsbyLink} to="/privacy/">
          Privacy policy
        </Link>
      </Text>
      {process.env.GATSBY_SUSTAINABILITY_DOCUMENT_URL && (
        <Text variant="smallprint">
          <a href={process.env.GATSBY_SUSTAINABILITY_DOCUMENT_URL}>
            Sustainability
          </a>
        </Text>
      )}
    </Flex>
  )
}
